const timeline = [
  {
    year: "2020",
    text: "A serious accident led to three back surgeries — including a full disc replacement — and the end of sports as I knew them.",
  },
  {
    year: "2020–2024",
    text: "Four and a half years of major pain, recovery, and rebuilding. Life completely changed.",
  },
  {
    year: "2024",
    text: "Cleared to play. My son and I searched for a sport I could come back to — pickleball. I fell in love instantly.",
  },
  {
    year: "2024",
    text: "Hit a wall: no real way to train without an open court and at least two players. Time to build my own.",
  },
  {
    year: "2024",
    text: "Went all in. Built the original Pickle Wall at home from painter's blue tape and an old volleyball net — mapped out to full regulation size so I could train solo every single day.",
  },
  {
    year: "2024",
    text: "Within one year — without ever playing before — I became a 4.5 DUPR player. Pure proof that repetition is the secret to mastering the game.",
  },
  {
    year: "2024",
    text: "Enrolled as an adult student at the University of Miami studying Sports Administration, Psychology, and Artificial Intelligence — laying the groundwork for the smart training experience behind Pickle Wall.",
  },
  {
    year: "2025",
    text: "Pickle Wall™ was born — the net, the kitchen lines, and the app working together to help millions of players train in their garage and take their game to another level.",
  },
];

export default function Founder() {
  return (
    <section id="our-story" className="relative py-24 md:py-36 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div className="relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden border border-white/10 relative">
              <img
                src="https://customer-assets.emergentagent.com/job_pickle-trainer-v1/artifacts/9lg3tdlm_image.png"
                alt="Juan Carlos Diaz and his son Jamieson wearing Pickle Wall hoodies"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-2">
                  Founder & Son · Hold The Line
                </div>
                <div className="font-display text-3xl font-black uppercase">
                  Juan Carlos &amp; Jamieson
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 glass rounded-2xl px-6 py-4 hidden md:block">
              <div className="text-xs uppercase tracking-widest text-white/60 mb-1">
                Survivor · Father · Builder
              </div>
              <div className="font-display text-lg font-bold uppercase">
                Pickle Wall™
              </div>
            </div>
          </div>

          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">
              The Story
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-balance leading-[0.95]">
              Meet The <br />
              <span className="text-[#FF6B00]">Founder</span>
            </h2>
            <p className="mt-6 text-lg text-white/75 leading-relaxed">
              In 2020, a serious accident changed everything for Juan. Three
              back surgeries — including a full disc replacement — meant the
              end of every sport he loved.
            </p>
            <p className="mt-4 text-lg text-white/75 leading-relaxed">
              For four and a half years he battled major pain and recovery. The
              day he was finally cleared to play, his son helped him search for
              a sport he could come back to. They found pickleball. He fell in
              love instantly.
            </p>
            <p className="mt-4 text-lg text-white/75 leading-relaxed">
              But there was a problem: you couldn&apos;t really train without
              an open court and at least two players. So Juan built one. That
              prototype became <span className="text-white font-semibold">Pickle Wall™</span> —
              built for every player who refuses to wait on a partner, a court,
              or a comeback.
            </p>
            <p className="mt-4 text-lg text-white/75 leading-relaxed">
              He started a year ago with nothing but a basic wooden paddle set,
              learning the game side-by-side with his son. Those simple paddles
              forced him to perfect the fundamentals — kitchen control,
              footwork, grip, body position — long before relying on any pro
              gear.
            </p>
            <div className="mt-6 glass rounded-2xl p-5 border-l-4 border-[#FF6B00]">
              <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-1">
                Founder&apos;s Vision
              </div>
              <p className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white leading-tight">
                &ldquo;This is the <span className="text-[#FF6B00]">Peloton</span> for pickleball.&rdquo;
              </p>
            </div>

            <div className="mt-10">
              <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-6">
                Timeline
              </div>
              <ol className="relative border-l border-white/10 ml-2 space-y-6">
                {timeline.map((t, i) => (
                  <li key={`${t.year}-${i}`} className="pl-6">
                    <div className="absolute -left-[7px] w-3 h-3 bg-[#FF6B00] rounded-full mt-2" />
                    <div className="font-display font-black text-[#FF6B00] text-lg uppercase tracking-wider">
                      {t.year}
                    </div>
                    <div className="text-white/75 mt-1">{t.text}</div>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
